import PlantCards from 'components/cards/plant-cards';

const PlantPage = () => {
  return <PlantCards />;
};

export default PlantPage;
